export default __webpack_public_path__ + "static/media/lush.1ee02246.svg";